import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ea-dash-card',
    templateUrl: './ea-dash-card.component.html',
    styleUrls: ['./ea-dash-card.component.scss'],
    standalone: false
})
export class EaDashCardComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
